import apiClient from '../apiClient';

const fileUploadService = {
  // Upload offer documents
  uploadOfferDocuments: async (files) => {
    try {
      const formData = new FormData();

      // Add files to FormData
      files.forEach((file, index) => {
        formData.append('documents', file);
      });

      const response = await apiClient.post('/recruitment/offers/upload-documents', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload single file
  uploadSingleFile: async (file) => {
    try {
      const formData = new FormData();
      formData.append('document', file);

      const response = await apiClient.post('/recruitment/offers/upload-single', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload profile picture to Cloudinary
  uploadProfilePicture: async (file) => {
    try {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        throw new Error('Only image files are allowed');
      }

      // Validate file size (max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        throw new Error('File size must be less than 5MB');
      }

      const formData = new FormData();
      formData.append('file', file);

      // Use dedicated profile picture endpoint (no permission check required, only auth)
      const response = await apiClient.post('/upload/profile-picture', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.responseCode === 200 && response.data) {
        return {
          success: true,
          url: response.data.url,
          public_id: response.data.public_id
        };
      } else {
        throw new Error(response.responseMessage || 'Upload failed');
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to upload profile picture'
      };
    }
  },

  // Upload any file to Cloudinary
  uploadToCloudinary: async (file, folder = 'background-verifications') => {
    try {
      // Validate file size (max 25MB as requested)
      const maxSize = 25 * 1024 * 1024;
      if (file.size > maxSize) {
        throw new Error('File size must be less than 25MB');
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('folder', folder);

      const response = await apiClient.post('/upload/cloudinary', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.responseCode === 200 && response.data) {
        return {
          success: true,
          url: response.data.url,
          public_id: response.data.public_id,
          format: response.data.format,
          resource_type: response.data.resource_type
        };
      } else {
        throw new Error(response.responseMessage || 'Upload failed');
      }
    } catch (error) {
      return {
        success: false,
      };
    }
  },

  // Delete file from Cloudinary
  deleteFromCloudinary: async (publicId, resourceType = 'raw') => {
    try {
      if (!publicId) throw new Error('Public ID is required for deletion');

      const response = await apiClient.delete(`/upload/cloudinary?public_id=${publicId}&resource_type=${resourceType}`);

      if (response.responseCode === 200) {
        return { success: true, message: response.responseMessage };
      } else {
        throw new Error(response.responseMessage || 'Deletion failed');
      }
    } catch (error) {
      return {
        success: false,
        error: error?.response?.data?.responseMessage || error.message || 'Failed to delete file'
      };
    }
  }
};

export default fileUploadService;

